import { Component } from "@angular/core";

@Component({
  selector: "app-re-edit-confirm-dialog",
  templateUrl: "./re-edit-confirm-dialog.component.html",
  styleUrls: ["./re-edit-confirm-dialog.component.scss"],
  standalone: false
})
export class ReEditConfirmDialogComponent {
  constructor() {}
}
